import { compact, get, orderBy, set } from 'lodash'

export function ensureParamToArray (param) {
  return compact(param.toString().replace(/"|\[|\]/g, '').split(','))
}

export function arrayIfFilter (a) { return !Array.isArray(a) ? a : a.filter(i => get(i, 'if', true)) }

export function replaceInArray (array, items, property) {
  const newArray = array
  for (const item of ensureParamToArray(items)) {
    const index = newArray.findIndex((arrayItem) => arrayItem[property] === item[property])
    if (index) set(newArray, `[${index}]`, item)
  }
  return newArray
}

export function alphabeticalOrder (array) {
  return orderBy(array, [(item) => (item.label ?? item).toLowerCase()], ['asc'])
}
